import React, { Component } from 'react'
import { connect } from 'react-redux'
import { autobind } from 'react-decoration'
import url from 'url'
import { actions } from 'mindself-api-client'

const { ContentActions, HTTPClientActions, UserActions } = actions

const Triangle = () => {
  return (
    <div className="triangle">
      <div className="col" />
      <div className="row" />
      <style jsx>{`
        .triangle {
          width: 24px;
          height: 24px;
          position: relative;
          cursor: pointer;
          top: 2px;
        }
        .col,
        .row {
          width: 2px;
          height: 13px;
          background-color: #000000;
          position: absolute;
          left: 5px;
        }
        .col {
          top: 0;
          transform: rotate(45deg);
        }
        .row {
          top: 8px;
          transform: rotate(135deg);
        }
      `}</style>
    </div>
  )
}

const NavBar = ({ title, onBackClick }) => {
  return (
    <div className="nav-bar">
      <div onClick={onBackClick}>
        <Triangle />
      </div>
      <h3 className="title">
        {title}
      </h3>
      <style jsx>{`
        .nav-bar {
          display: flex;
          align-items: center;
          position: relative;
          height: 64px;
          padding: 0 20px;
        }
        .title {
          color: #707070;
          font-size: 14px;
          margin: 0;
        }
      `}</style>
    </div>
  )
}

@connect(null, { ...ContentActions, ...HTTPClientActions, ...UserActions })
export default class ContentPage extends Component {
  state = { title: '', url: '' }

  async componentDidMount() {
    // get userId
    const { isLogin, setAuthorizationInfo } = this.props
    const isLoginRes = await isLogin()
    const userId = isLoginRes.result
    setAuthorizationInfo(userId)

    // get contentId
    const currentUrl = window.location.href
    const qs = url.parse(currentUrl, true).query
    const contentId = qs.id

    // get content
    const { getContent } = this.props
    const content = (await getContent(contentId)).result

    this.setState(() => ({
      title: content.title,
      url: content.origin.split('url:')[1],
    }))
  }

  @autobind
  handleBackClick() {
    this.props.router.push('/')
  }

  render() {
    const { title, url } = this.state

    return (
      <div>
        <NavBar onBackClick={this.handleBackClick} title={title} />
        <iframe src={url} />
        <style jsx>{`
          iframe {
            width: 100%;
            height: calc(100vh - 64px);
          }
        `}</style>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/content.js